import React, { useState, useEffect } from 'react';
import './GroupParam.css';
import PositiveIcon from '../media/imagen/posismile.svg';
import NegativeIcon from '../media/imagen/badsmile.svg';
import NeutralIcon from '../media/imagen/neutralsmile.svg';
import PoyStatus from '../media/imagen/PoyStatus.svg'

const Status = ({ testID }) => {
    const [statusData, setStatusData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchStatusData = async () => {
            try {
                const token = localStorage.getItem('authToken');
                if (!token) throw new Error('Токен авторизации не найден');

                const response = await fetch(
                    `http://185.250.149.189:8000/api/v1/Results/Sociometric/Status?test_id=${testID}`,
                    {
                        method: 'GET',
                        headers: {
                            'Authorization': `Token ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (!response.ok) throw new Error(`Ошибка HTTP: ${response.status}`);
                const result = await response.json();
                setStatusData(result);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchStatusData();
    }, [testID]);

    useEffect(() => {
        console.log(statusData)
    }, [statusData]);

    if (loading) return <div className="loading">Загрузка данных...</div>;
    if (error) return <div className="error">Ошибка: {error}</div>;
    if (!statusData) return <div className="no-data">Нет данных для отображения</div>;

    return (
        <div>
        <br />
        <br />
        <img src={PoyStatus}></img>
        <br />
        <br />
        <div className="GroupParam-container">
            {/* Положительный статус */}
            <div className='GroupParam-card relative'>
                <img 
                    src={PositiveIcon} 
                    alt="Положительный статус" 
                    className="group-icon"
                />
                <h2>Положительный статус</h2>
                <span className='BigNum'>{statusData.results.count_pos_users} из {statusData.results.count_users} </span>
                <div className='help-param'>
                    __________
                    <br />
                    <br />
                    <span className='GroupParam-help'>
                        Участники с положительным статусом получают много положительных выборов и мало отрицательных. Они являются лидерами и пользуются авторитетом в группе.
                    </span>
                </div>
            </div>

            {/* Нейтральный статус */}
            <div className='GroupParam-card relative'>
                <img 
                    src={NeutralIcon} 
                    alt="Нейтральный статус" 
                    className="group-icon"
                />
                <h2>Нейтральный <br /> статус</h2>
                <span className='BigNum'>{statusData.results.count_neutral_users} из {statusData.results.count_users} </span>
                <div className='help-param'>
                    __________
                    <br />
                    <br />
                    <span className='GroupParam-help'>
                        Участники с нейтральным статусом получают примерно равное количество 
                        положительных и отрицательных выборов. Они не выделяются в группе 
                        и занимают среднее положение.
                    </span>
                </div>
            </div>

            {/* Отрицательный статус */}
            <div className='GroupParam-card relative'>
                <img 
                    src={NegativeIcon} 
                    alt="Отрицательный статус" 
                    className="group-icon"
                />
                <h2>Отрицательный  статус</h2>
                <span className='BigNum'>{statusData.results.count_bad_users} из {statusData.results.count_users} </span>
                <div className='help-param'>
                    __________
                    <br />
                    <br />
                    <span className='GroupParam-help'>
                        Участники с отрицательным статусом получают много отрицательных выборов 
                        и мало положительных. Они находятся в изоляции или отвергаются группой.
                    </span>
                </div>
            </div>
        </div>
        </div>
    );
};

export default Status;